import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

function GoogleMaps() {
  useEffect(() => {
    // Load Elfsight script if not already loaded
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      // Clean up function
      return () => {
        // Only remove if we added it
        const existingScript = document.querySelector('script[src="https://elfsightcdn.com/platform.js"]');
        if (existingScript && existingScript.parentNode) {
          existingScript.parentNode.removeChild(existingScript);
        }
      };
    }
  }, []);

  return (
    <section className="py-16 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Unser Standort
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Besuchen Sie uns in Heinsberg oder nutzen Sie unsere Karte für eine einfache Anfahrt zu unserem Betrieb.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="w-full"
        >
          {/* Google Maps - Full Width */}
          <div className="w-full bg-white rounded-xl overflow-hidden shadow-lg">
            <div 
              className="elfsight-app-18f4f5ca-03eb-48d7-806c-9ef26541e0cb w-full min-h-[400px]" 
              data-elfsight-app-lazy
            ></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default GoogleMaps;